import { initHeader } from './blocks/header';
import { initSmoothScroll } from './blocks/smooth-scroll';
var documentReady = function () {
    initSmoothScroll();
    initHeader();
};

if (
    document.readyState === 'complete' ||
    (document.readyState !== 'loading' && !document.documentElement.doScroll)
) {
    documentReady();
} else {
    document.addEventListener('DOMContentLoaded', documentReady);
}
